<template>
    <div class="bg-white rounded shadow-sm mb-3">
        <!-- Header Start -->
<div class="d-flex flex-row align-items-center justify-content-between flex-wrap mb-3" style="padding: 20px 20px 10px 20px">

    <!-- Kiri: judul + filter dealer & status -->
    <div class="d-flex align-items-center flex-wrap">
        <h3 class="h5 font-weight-semibold mb-0 mr-4 my-1" style="color: #2F2F2F;">Riwayat Pengirim</h3>

        <!-- Dropdown All Dealer -->
        <div class="mr-3 my-1" style="width: 160px;">
            <MultiSelect
                v-model="selectedDealer"
                :options="dealerOptions"
                class="qtrust-select"
                placeholder="All Dealer"
                :allow-empty="true"
            ></MultiSelect>
        </div>

        <!-- Dropdown All Status -->
        <div class="my-1 text-nowrap" style="width: 140px;">
            <MultiSelect
                v-model="filter.status"
                :options="['INTRANSIT', 'RECEIVED']"
                :custom-label="formatStatusLabel"
                class="qtrust-select"
                :class="{ 'qtrust-select--active': !!filter.status }"
                placeholder="All Status"
                :allow-empty="true"
            ></MultiSelect>
        </div>
    </div>

    <!-- Kanan: tombol aksi -->
    <div class="d-flex align-items-center flex-wrap">
        <!-- Download XLS Button -->
        <button
            type="button"
            class="btn btn-download-xls mr-3 my-1 text-nowrap"
            @click="downloadAll"
        >
            Download XLS
            <i class="fas fa-file-download ml-2"></i>
        </button>

        <!-- Buat Delivery Button -->
        <button
            class="btn btn-buat-delivery my-1 text-nowrap"
            @click="$emit('showMetodeModal')"
            v-if="$store.state.userData.userData.role !== 'USER SE'"
        >
            Buat Delivery
        </button>
    </div>
</div>
<!-- Header End -->
        <!-- Header End -->

        <!-- Table Start (Scrollable Left-Right) -->
        <div class="w-100 overflow-auto table-scroll-container">
            <table class="table w-100 qtrust-table" style="min-width: 1400px;">
                <thead>
                    <tr>
                        <th class="clickHover" @click="sortClick('delivery_at')">Tanggal Pengiriman <i class="fas" :class="config.sort_by == 'delivery_at' ? config.sort_order == 'asc' ? 'fa-sort-up' : 'fa-sort-down' : 'fa-sort'"></i></th>
                        <th class="clickHover" @click="sortClick('qty')">Jumlah QR <i class="fas" :class="config.sort_by == 'qty' ? config.sort_order == 'asc' ? 'fa-sort-up' : 'fa-sort-down' : 'fa-sort'"></i></th>
                        <th class="clickHover" @click="sortClick('ahm_id')">ID AHM <i class="fas" :class="config.sort_by == 'ahm_id' ? config.sort_order == 'asc' ? 'fa-sort-up' : 'fa-sort-down' : 'fa-sort'"></i></th>
                        <th class="clickHover" @click="sortClick('kode_dealer')">Kode Dealer <i class="fas" :class="config.sort_by == 'kode_dealer' ? config.sort_order == 'asc' ? 'fa-sort-up' : 'fa-sort-down' : 'fa-sort'"></i></th>
                        <th class="clickHover" @click="sortClick('dealer')">Nama Dealer <i class="fas" :class="config.sort_by == 'dealer' ? config.sort_order == 'asc' ? 'fa-sort-up' : 'fa-sort-down' : 'fa-sort'"></i></th>
                        <th class="clickHover" @click="sortClick('city')">Kabupaten <i class="fas" :class="config.sort_by == 'city' ? config.sort_order == 'asc' ? 'fa-sort-up' : 'fa-sort-down' : 'fa-sort'"></i></th>
                        <th class="clickHover" @click="sortClick('dealer_type')">Status Jaringan <i class="fas" :class="config.sort_by == 'dealer_type' ? config.sort_order == 'asc' ? 'fa-sort-up' : 'fa-sort-down' : 'fa-sort'"></i></th>
                        <th class="clickHover" @click="sortClick('status')">Status <i class="fas" :class="config.sort_by == 'status' ? config.sort_order == 'asc' ? 'fa-sort-up' : 'fa-sort-down' : 'fa-sort'"></i></th>
                        <th class="clickHover" @click="sortClick('bast_no')">Kode BAST <i class="fas" :class="config.sort_by == 'bast_no' ? config.sort_order == 'asc' ? 'fa-sort-up' : 'fa-sort-down' : 'fa-sort'"></i></th>
                        <th class="clickHover" @click="sortClick('sender_name')">Nama Pengirim <i class="fas" :class="config.sort_by == 'sender_name' ? config.sort_order == 'asc' ? 'fa-sort-up' : 'fa-sort-down' : 'fa-sort'"></i></th>
                        <th class="clickHover" @click="sortClick('received_at')">Tanggal Receipt <i class="fas" :class="config.sort_by == 'received_at' ? config.sort_order == 'asc' ? 'fa-sort-up' : 'fa-sort-down' : 'fa-sort'"></i></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody v-if="data">
                    <tr v-for="(dat, index) in data" :key="index">
                        <td>{{ dat.delivery_at ? moment(dat.delivery_at).format('DD MMM YYYY | HH:mm') : '-' }}</td>
                        <td>{{ dat.qty ? numberWithCommas(dat.qty) : '-' }}</td>
                        <td>{{ dat.ahm_id ? dat.ahm_id : '-'  }}</td>
                        <td>{{ dat.kode_dealer ? dat.kode_dealer : '-'  }}</td>
                        <td>{{ dat.dealer ? dat.dealer : '-'  }}</td>
                        <td>{{ dat.city ? dat.city : '-'  }}</td>
                        <td>{{ dat.dealer_type ? dat.dealer_type : '-'  }}</td>
                        <td>{{ dat.status ? dat.status : '-' }}</td>
                        <td>{{ dat.bast_no ? dat.bast_no : '-' }}</td>
                        <td>{{ dat.sender_name ? dat.sender_name : '-' }}</td>
                        <td>
                            {{ dat.received_at ? moment(dat.received_at).format('DD MMM YYYY | HH:mm') : '-' }}
                        </td>
                        <td>
                            <div class="d-flex justify-content-between" v-if="$store.state.userData.userData.role !== 'USER SE'">
                                <i v-if="dat.status == 'INTRANSIT'" class="fa fa-edit text-primary ml-2 clickHover" title="Edit"  @click="$emit('editData', dat)"></i>
                                <i v-if="dat.status == 'INTRANSIT'" class="fa fa-trash text-danger ml-2 clickHover" title="Hapus" @click="deleteQRIssue(dat.id)"></i>
                                <i class="fa fa-file-download ml-2 clickHover" title="Download BAST" @click="printReceiptMethod(dat)"></i>
                            </div>
                            <div class="d-flex justify-content-between" v-else>
                                <i class="fa fa-file-download ml-2 clickHover" title="Download BAST" @click="printReceiptMethod(dat)"></i>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- Table End -->

        <div class="d-flex justify-content-end align-items-center py-2 px-3" v-if="data">
            <p class="text-muted mb-0" style="font-size: 13px;">Showing {{ (config.page-1)*config.limit+1 }}-{{ (config.page-1)*config.limit+data.length }} of {{ config.total }} Items</p>
            <div class="d-flex align-items-center text-muted ml-3">
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(1)"><i class="fa fa-angle-double-left"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(config.page - 1)"><i class="fa fa-angle-left"></i></button>
                <p class="px-2 text-dark mb-0" style="font-size: 13px;">{{ config.page }}</p>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.page + 1)"><i class="fa fa-angle-right"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.lastPage)"><i class="fa fa-angle-double-right"></i></button>
            </div>
        </div>
        
        <print-receipt ref="printReceiptComponent" :data="receiptData"/>
    </div>
</template>

<script>
    import moment from 'moment';
    import PrintReceipt from './printReceipt.vue';
    import * as XLSX from 'xlsx';

    export default {
        props : {
            startDate : { type: String, default: null },
            endDate : { type: String, default: null }
        },
        data () {
            return {
                moment,
                receiptData : null,
                selectedDealer: null,
                data : null,
                filter : {
                    status : null,
                    start_date : this.startDate,
                    end_date : this.endDate,
                    dealer_type: null,
                    kode_dealer: null,
                },
                config : {
                    page: 1,
                    limit: 15,
                    lastPage: 0,
                    total: 0,
                    sort_by: 'delivery_at',
                    sort_order: 'DESC'
                },
            }
        },
        components : {
            PrintReceipt
        },
        computed: {
            dealerOptions() {
                try {
                    const dealerList = this.$store.getters.getDealer ? this.$store.getters.getDealer() : [];
                    const names = dealerList.map(x => x.name).filter(Boolean);
                    const types = ['H1', 'H23', 'H123'];
                    return [...types, ...names];
                } catch(e) {
                    return ['H1', 'H23', 'H123'];
                }
            }
        },
        watch : {
            // sinkron tanggal dari parent
            startDate (v) { this.filter.start_date = v },
            endDate (v) { this.filter.end_date = v },

            selectedDealer(val) {
                if (!val || val === 'All Dealer') {
                    this.filter.dealer_type = null;
                    this.filter.kode_dealer = null;
                } else if (['H1', 'H23', 'H123'].includes(val)) {
                    this.filter.dealer_type = val;
                    this.filter.kode_dealer = null;
                } else {
                    const dealerList = this.$store.getters.getDealer ? this.$store.getters.getDealer() : [];
                    const found = dealerList.find(x => x.name === val || x.code === val);
                    this.filter.kode_dealer = found ? found.code : val;
                    this.filter.dealer_type = null;
                }
            },
            'filter' : {
                deep: true,
                handler () {
                    this.config.page = 1;
                    this.generateDatas();
                    this.$emit('filterChange', { ...this.filter });
                },
            },
            'config.page' : {
                deep: true,
                handler: 'generateDatas'
            }
        },
        mounted () {
            this.generateDatas();
            this.$emit('filterChange', { ...this.filter });
        },
        methods : {
            // dipanggil parent saat klik link di card "QR Dalam Perjalanan"
            setStatus (status) {
                this.filter.status = status;
            },
            formatStatusLabel(opt) {
                if (opt === 'INTRANSIT') return 'In-Transit';
                if (opt === 'RECEIVED') return 'Received';
                return opt;
            },
            goToPage(page) {
                if (page >= 1 && page <= this.config.lastPage) this.config.page = page;
            },
            sortClick(sort_by) {
                if (this.config.sort_by == sort_by) {
                    this.config.sort_order = this.config.sort_order == 'asc' ? 'desc' : 'asc';
                } else {
                    this.config.sort_by = sort_by;
                    this.config.sort_order = 'desc';
                }
                this.generateDatas();
            },
            async printReceiptMethod(data) {
                try {
                    let id = data.id;
                    let response = await this.$http.get('/api/qrs/issue/' + id);
                    this.receiptData = response.data.data;
                    this.$refs.printReceiptComponent.generateReport();
                }
                catch(err) {
                    console.log(err);
                }
            },
            async generateDatas() {
                let filter = JSON.parse(JSON.stringify(this.filter));
                let configs = JSON.parse(JSON.stringify(this.config));
                delete configs.lastPage;
                delete configs.total;

                this.$http.get(`/api/qrs/issue?`, {params: {...filter, ...configs}})
                .then(async res => {
                    let data = res.data.data;
                    this.data = data;

                    this.config.lastPage = res.data.meta.lastPage;
                    this.config.total = res.data.meta.total;

                    this.$nextTick(() => {
                        document.dispatchEvent(new Event('click'));
                    });
                })
                .catch((err)=>console.log(err));
            },
            deleteQRIssue(issueId) {
                this.$swal.fire({
                    html: `<div class="text-center my-2" style="color: #000000;"><h4>Apakah Anda yakin?</h4>
                        <div>Data yang telah dihapus tidak dapat dikembalikan lagi</div>               
                        </div>`,
                    type : 'warning',
                    showCancelButton: true,
                    cancelButtonText: `Batal`,
                    confirmButtonText: `Hapus`,
                    reverseButtons: true,
                    customClass: {
                        confirmButton: "btn btn-danger btn-lg mx-2",
                        cancelButton: "btn btn-outline btn-outline-danger btn-lg mx-2"
                    },
                    buttonsStyling: false
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete(`/api/qrs/issue/${issueId}`)
                        .then(() => {
                            this.generateDatas();
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                    }
                });
            },
            async downloadAll() {
                try {
                    const filter = { ...this.filter, limit: this.config.total };
                    const response = await this.$http.get('/api/qrs/issue', { params: filter }).then(res => res.data.data);

                    const customHeaders = {
                        'delivery_at': 'Tanggal Pengiriman',
                        'qty': 'Jumlah QR',
                        'ahm_id': 'AHM ID',
                        'kode_dealer': 'Kode Dealer',
                        'dealer': 'Nama Dealer',
                        'city': 'Kabupaten',
                        'dealer_type': 'Status Jaringan',
                        'status': 'Status',
                        'bast_no': 'Kode BAST',
                        'sender_name': 'Nama Pengirim',
                        'received_at': 'Tanggal Receipt'
                    };

                    const modifiedData = response.map(item => {
                        const newItem = {};
                        for (const [oldKey, newKey] of Object.entries(customHeaders)) {
                            if (Object.prototype.hasOwnProperty.call(item, oldKey)) {
                                if (oldKey === 'delivery_at' || oldKey === 'received_at') {
                                    newItem[newKey] = item[oldKey] ? moment(item[oldKey]).format('DD MMM YYYY | HH:mm') : '-';
                                } else {
                                    newItem[newKey] = item[oldKey] ? item[oldKey] : '-';
                                }
                            }
                        }
                        return newItem;
                    });

                    const worksheet = XLSX.utils.json_to_sheet(modifiedData, { header: Object.values(customHeaders) });

                    const columnLetter = 'C';
                    Object.keys(worksheet).forEach(cellAddress => {
                        if (cellAddress.startsWith(columnLetter)) {
                            worksheet[cellAddress].t = 's';
                        }
                    });

                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                    const timestamp = moment().format('DDMMYYYYHHmmss');
                    const fileSuffix = `${this.filter.start_date}_${this.filter.end_date}`;
                    const filename = `qr_issue_${fileSuffix}_${timestamp}.xlsx`;
                    XLSX.writeFile(workbook, filename);

                } catch (error) {
                    console.error('Error fetching data or exporting XLSX:', error);
                }
            },
        },
    }
</script>

<style>
    .qtrust-select {
        min-height: 0;
    }

    .qtrust-select .multiselect__tags {
        min-height: 0;
        height: 32px;
        padding: 4px 40px 0 8px;
        border: 1px solid #E2E8F0;
        border-radius: 4px;
    }

    .qtrust-select .multiselect__tags .multiselect__placeholder {
        margin: 0;
        padding: 0;
        font-size: 13px;
        color: #4B5563;
    }

    .qtrust-select .multiselect__select {
        height: 32px;
    }

    .qtrust-select .multiselect__select::before {
        z-index: 1;
        margin: 0;
    }

    .qtrust-select .multiselect__single {
        margin: 0;
        font-size: 13px;
        color: #1F2937;
    }

    .qtrust-select.qtrust-select--active .multiselect__tags {
        border-color: #F36F21;
    }
</style>

<style scoped>
    .btn-download-xls {
        background-color: white;
        border: 1px solid #E2E8F0;
        padding: 0 16px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        font-size: 13px;
        cursor: pointer;
        font-weight: 500;
        color: #1F2937;
        height: 32px;
    }

    .btn-download-xls:hover {
        background-color: #F8FAFC;
    }

    .btn-buat-delivery {
        background-color: #F36F21;
        color: white;
        border-radius: 4px;
        border: none;
        height: 32px;
        padding: 0 18px;
        font-size: 13px;
        font-weight: 500;
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .btn-buat-delivery:hover {
        background-color: #e06216;
        color: white;
    }

    .table-scroll-container {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .table-scroll-container::-webkit-scrollbar {
        height: 7px;
    }

    .table-scroll-container::-webkit-scrollbar-track {
        background: #F3F4F6;
        border-radius: 4px;
    }

    .table-scroll-container::-webkit-scrollbar-thumb {
        background: #D1D5DB;
        border-radius: 4px;
    }

    .table-scroll-container::-webkit-scrollbar-thumb:hover {
        background: #9CA3AF;
    }

    .clickHover:hover {
        cursor: pointer;
    }

    .qtrust-table > thead > tr > th {
        text-align: left;
        border-top: 2px solid #F3F3F3;
        border-bottom: 2px solid #F3F3F3;
        padding: 10px 16px;
        height: 48px;
        vertical-align: middle;
        font-size: 13px;
        font-weight: 600;
        color: #2F2F2F;
        white-space: nowrap;
    }

    .qtrust-table > tbody > tr > td {
        text-align: left;
        padding: 10px 16px;
        border-bottom: 1px solid #F3F3F3;
        height: 48px;
        vertical-align: middle;
        font-size: 13px;
        color: #374151;
        white-space: nowrap;
    }
</style>